module.exports = __webpack_public_path__ + "img/opap-webhook.48e7af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/opap-webhook.png
// module id = Kbnt
// module chunks = 39 44